import useSWR from "swr";
import { getReplacementValues } from "../services/template-service";
import type {
  ReplacementValuesResponse,
  ReplacementValueItem,
} from "../types/api-types";

export interface UseReplacementValuesReturn {
  replacementValues: ReplacementValueItem[] | undefined;
  isLoading: boolean;
  // SWR returns any, so a more explicit type cannot be used
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  mutate: () => void;
}

const useReplacementValues = (
  templateId: number | null,
): UseReplacementValuesReturn => {
  const { data, error, isLoading, mutate } = useSWR<ReplacementValuesResponse>(
    templateId ? `replacement-values-${templateId}` : null,
    () => (templateId ? getReplacementValues(templateId) : Promise.resolve([])),
  );

  return {
    replacementValues: data,
    isLoading,
    error,
    mutate,
  };
};

export default useReplacementValues;
